import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import { updateMeta } from "../../store/actions/metaAction";
import { Col, Row, Container } from "reactstrap";

const TeamMemberShow = ({ match }) => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const [isUploading, setIsUploading] = useState(false);

	const [teamMember, setTeamMember] = useState({
		img: "",
		name: { ar: "", en: "" },
		job: { ar: "", en: "" },
	});
	const [picture, setPicture] = useState({
		blob: true,
		path: userPlaceholder,
		placeholder: true,
	});

	const {
		params: { teamMemberSlug },
	} = match;
	const dispatch = useDispatch();

	const onStart = () => {
		dispatch(
			updateMeta({
				title: " تعديل عضو الفريق",
				breadcrumb: "أعضاء الفريق",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			.get(
				`${process.env.REACT_APP_API_URL}pages/teamMembers/sections/${teamMemberSlug}`,
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(response => {
				setTeamMember({ ...response.data.data.section });
				setPicture({
					...picture,
					path: `${process.env.REACT_APP_MAIN_URL}/${response?.data?.data?.section?.img}`,
				});
			});
	};

	useEffect(() => {
		onStart();
	}, []);

	const handlePicture = e => {
		const pictureElement = document.querySelector("#picture");
		const mainImage = new FormData();
		mainImage.append("file", pictureElement.files[0]);
		setIsUploading(true);
		axios
			.post(`${process.env.REACT_APP_MAIN_URL}/api/upload`, mainImage, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
					"Content-Type": "multipart/form-data",
				},
			})
			.then(response => {
				setIsUploading(false);
				setPicture({
					...picture,
					path: `${process.env.REACT_APP_MAIN_URL}/${response.data.data.file.path}`,
				});
				setTeamMember({
					...teamMember,
					img: response.data.data.file.path,
				});
			})
			.catch(_ => {
				setIsUploading(false);
				toast.error("حدث خطا أثناء رفع الصورة");
				setTimeout(
					__ => toast.warn("الرجاء المحاولة مره اخرة او تغير الصورة"),
					800
				);
			});
	};

	const handleSubmit = e => {
		e.preventDefault();
		// التحقق من الحقول
		if (
			!teamMember.name?.ar.trim() ||
			!teamMember.name?.en.trim() ||
			!teamMember.job?.ar.trim() ||
			!teamMember.job?.en.trim()
		) {
			toast.error("يرجى ملء جميع الحقول باللغة العربية والإنجليزية");
			return;
		}

		axios
			.put(
				`${process.env.REACT_APP_API_URL}pages/teamMembers/sections/${teamMemberSlug}`,
				{
					section: teamMember,
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(
				_ =>
					toast.success("تم تعديل البيانات بنجاح") &&
					history.push("/teamMembers/index")
			)
			.catch(_ => toast.error("حدث خطا !"));
	};

	return (
		<section>
			<Container>
				<div className="card">
					<div className="card-body">
						<Row>
							<Col>
								<div className="form-item">
									<label htmlFor="picture">صورة </label>
									<input type="file" onChange={handlePicture} id="picture" />
									{isUploading ? (
										<p style={{ marginTop: "1rem" }}> ...جارى رفع الصورة</p>
									) : (
										<img
											src={
												picture && picture.blob
													? picture.path
													: `${process.env.REACT_APP_MAIN_URL}/${picture.path}`
											}
											alt="avatar"
											className="imagePreview-2"
										/>
									)}
								</div>
							</Col>
						</Row>
						<Row style={{ marginTop: "2rem" }}>
							<Col md={6} xs={12}>
								<div
									className="form-item"
									style={{
										display: "flex",
										flexDirection: "column",
										justifyContent: "flex-start",
										alignItems: "flex-start",
									}}
								>
									<label htmlFor="nameAr">الاسم باللغة العربية </label>

									<input
										type="text"
										id="nameAr"
										name="nameAr"
										value={teamMember?.name?.ar ?? ""}
										onChange={e => {
											setTeamMember({
												...teamMember,
												name: {
													...teamMember.name,
													ar: e.target.value,
												},
											});
										}}
									/>
								</div>
							</Col>

							<Col md={6} xs={12}>
								<div
									className="form-item"
									style={{
										display: "flex",
										flexDirection: "column",
										justifyContent: "flex-start",
										alignItems: "flex-start",
									}}
								>
									<label htmlFor="nameEn">الاسم باللغة الانجليزية</label>

									<input
										type="text"
										id="nameEn"
										name="nameEn"
										value={teamMember?.name?.en ?? ""}
										onChange={e => {
											setTeamMember({
												...teamMember,
												name: {
													...teamMember.name,
													en: e.target.value,
												},
											});
										}}
									/>
								</div>
							</Col>
						</Row>

						<Row>
							<Col xs={12} md={6}>
								<div className="form-item">
									<label htmlFor="jobAR">الوظيفة باللغة العربية </label>

									<textarea
										name=""
										id="jobAR"
										rows="5"
										style={{ resize: "none", width: "100%" }}
										value={teamMember?.job?.ar ?? ""}
										onChange={e => {
											setTeamMember({
												...teamMember,
												job: { ...teamMember.job, ar: e.target.value },
											});
										}}
									></textarea>
								</div>
							</Col>
							<Col xs={12} md={6}>
								<div className="form-item">
									<label htmlFor="jobEN">الوظيفة باللغة الانجليزية</label>

									<textarea
										name=""
										id="jobEN"
										rows="5"
										value={teamMember?.job?.en ?? ""}
										style={{ resize: "none", width: "100%" }}
										onChange={e => {
											setTeamMember({
												...teamMember,
												job: { ...teamMember.job, en: e.target.value },
											});
										}}
									></textarea>
								</div>
							</Col>
						</Row>

						<Row>
							<Col>
								<div className="form-item mt-3">
									<button
										className="bt bt-success btn-block"
										onClick={handleSubmit}
									>
										ارسال
									</button>
								</div>
							</Col>
						</Row>
					</div>
				</div>
			</Container>
		</section>
	);
};

export default TeamMemberShow;
